var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Attribute, Component, Input, Output, EventEmitter } from '@angular/core';
var SyntaxHighlighterComponent = /** @class */ (function () {
    function SyntaxHighlighterComponent(elementRef, language, showClose) {
        this.elementRef = elementRef;
        this.defaultLanguage = 'js';
        this.onClose = new EventEmitter();
        this.language = language || this.defaultLanguage;
        this.showCloseButton = showClose || false;
    }
    Object.defineProperty(SyntaxHighlighterComponent.prototype, "burshClass", {
        get: function () {
            return 'brush: ' + this.language;
        },
        enumerable: true,
        configurable: true
    });
    SyntaxHighlighterComponent.prototype.ngOnChanges = function (changes) {
        var contentChange = changes['content'];
        var currentElement = $(this.elementRef.nativeElement);
        if (!contentChange) {
            return;
        }
        if (!contentChange.currentValue) {
            return;
        }
        this.language = this.language || this.defaultLanguage;
        setTimeout(function () {
            SyntaxHighlighter.highlight({
                toolbar: false,
                'quick-code': true
            }, currentElement.find('pre')[0]);
        });
    };
    SyntaxHighlighterComponent.prototype.close = function () {
        this.onClose.emit();
    };
    __decorate([
        Input()
    ], SyntaxHighlighterComponent.prototype, "title", void 0);
    __decorate([
        Input()
    ], SyntaxHighlighterComponent.prototype, "content", void 0);
    __decorate([
        Output()
    ], SyntaxHighlighterComponent.prototype, "onClose", void 0);
    SyntaxHighlighterComponent = __decorate([
        Component({
            selector: 'fc-syntax-highlighter',
            styles: [".design-syntaxheight{ .title { width: 100%; padding-left: 20px; padding-right: 5px; clear: both; } .tool { display: inline-block; float: right; } button span { font-size: 23px; line-height: 20px; } } "],
            template: "<div class=\"design-syntaxheight\"> <div class=\"title\"><span clip-text=\"40\">{{title}}</span> <span class=\"right tool\" *ngIf=\"showCloseButton\"> <button  class=\"close pull-right\" type=\"button\"  (click)=\"close()\" > <span >×</span> </button> </span> </div> <pre class=\"{{burshClass}}\">{{content}}</pre> </div>"
        }),
        __param(1, Attribute('language')),
        __param(2, Attribute('showCloseButton'))
    ], SyntaxHighlighterComponent);
    return SyntaxHighlighterComponent;
}());
export { SyntaxHighlighterComponent };
